"use client";

// LOAD A PAGE'S STORE GROUPS WHEN SOMEONE SHOWS THEY MEAN TO OPEN IT.
//
// A client navigation into a page whose groups the tab does not hold waits for
// them behind the group gate (components/store-group-gate.tsx): the Videos page
// from the sidebar, the editor from a row on Videos. The pointer reaches a link
// ~150–300 ms before the click, and a group load is about that long, so asking
// then hides most of the wait. The bytes are the ones the click would have
// fetched anyway; a hover with no click pays them once, since a held group is
// never let go and never asked for again.
//
// Called from IntentLink's hover, focus and touch (the sidebar, the crumbs, a
// button to another page) and from the Videos page's rows into the editor: a
// table's rows load one group between them, so sweeping the pointer down the
// table asks once, not per row.

import { pollStoreNow, wantGroups, wantedGroups } from "@/lib/store-cursor";
import { storeGroupsFor } from "@/lib/route-store-groups";

/**
 * Ask for the groups the page at `href` reads, unless the tab holds them or
 * has already asked: a pointer crossing ten rows while the load is out asks
 * once. A load that failed is asked again by the poll's own interval, and by
 * the click.
 */
export function loadGroupsOnIntent(href: string): void {
  const asked = wantedGroups().length;
  if (wantGroups(storeGroupsFor(href)) && wantedGroups().length > asked) void pollStoreNow();
}
